export class ApplicationsRoutingConstants {
    static APPLICATIONS_ROUTE = "applications";
    static REFRESH_ROUTE = "refresh";
    static REFRESH_VIEW_APPLICATION_ROUTE = "refreshViewApplication";
}
